(function () {
  const rootSelector = '[data-meet-experts-slider-root]';

  const updateLiveRegion = (root, swiper) => {
    const liveRegion = root.querySelector('[data-meet-experts-slider-live]');
    if (!liveRegion) return;

    liveRegion.textContent = `Showing slide ${swiper.realIndex + 1} of ${swiper.slides.length}`;
  };

  const updateArrowState = (root, swiper) => {
    if (!root) return;

    const previousButton = root.querySelector('[data-meet-experts-slider-previous]');
    const nextButton = root.querySelector('[data-meet-experts-slider-next]');

    if (previousButton) {
      previousButton.hidden = swiper.isBeginning;
    }

    if (nextButton) {
      nextButton.hidden = swiper.isEnd;
    }
  };

  const refreshSwiper = (swiper) => {
    window.requestAnimationFrame(() => {
      swiper.update();
      updateArrowState(swiper.el.closest(rootSelector), swiper);
    });

    window.setTimeout(() => {
      swiper.update();
      updateArrowState(swiper.el.closest(rootSelector), swiper);
    }, 250);
  };

  const initRoot = (root) => {
    if (root.dataset.meetExpertsSliderInitialized === 'true') return;

    const slider = root.querySelector('[data-meet-experts-slider]');
    if (!slider) return;

    if (typeof window.Swiper === 'undefined') {
      window.setTimeout(() => initRoot(root), 120);
      return;
    }

    root.dataset.meetExpertsSliderInitialized = 'true';

    const previousButton = root.querySelector('[data-meet-experts-slider-previous]');
    const nextButton = root.querySelector('[data-meet-experts-slider-next]');
    const pagination = root.querySelector('[data-meet-experts-slider-pagination]');

    const swiper = new window.Swiper(slider, {
      slidesPerView: 1.45,
      spaceBetween: 16,
      slidesOffsetBefore: 24,
      slidesOffsetAfter: 15,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      keyboard: { enabled: true, onlyInViewport: true },
      a11y: { enabled: true },
      pagination: {
        el: pagination,
        type: 'progressbar'
      },
      navigation: {
        prevEl: previousButton,
        nextEl: nextButton
      },
      breakpoints: {
        769: {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 24,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        }
      },
      on: {
        init() {
          updateLiveRegion(root, this);
          updateArrowState(root, this);
          refreshSwiper(this);
        },
        slideChange() {
          updateLiveRegion(root, this);
          updateArrowState(root, this);
        },
        reachBeginning() {
          updateArrowState(root, this);
        },
        reachEnd() {
          updateArrowState(root, this);
        },
        fromEdge() {
          updateArrowState(root, this);
        }
      }
    });

    if (document.readyState !== 'complete') {
      window.addEventListener('load', () => refreshSwiper(swiper), { once: true });
    }

    if (document.fonts) {
      document.fonts.ready.then(() => refreshSwiper(swiper));
    }

    root.meetExpertsSlider = swiper;
  };

  const initAll = () => {
    const roots = document.querySelectorAll(rootSelector);

    for (const root of roots) {
      initRoot(root);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.matches(rootSelector)
      ? event.target
      : event.target.querySelector(rootSelector);

    if (root) initRoot(root);
  });
})();
